import { render, staticRenderFns } from "./Scjy.vue?vue&type=template&id=5681910f&scoped=true"
import script from "./Scjy.vue?vue&type=script&lang=js"
export * from "./Scjy.vue?vue&type=script&lang=js"
import style0 from "./Scjy.vue?vue&type=style&index=0&id=5681910f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5681910f",
  null
  
)

export default component.exports